SNI.Application.addModule('tabbed-mobile-search', (context) => {

  return {

    behaviors: ['tab']

  };

});
